import { Component, ViewChild } from '@angular/core';
import { ComponentCanDeactivate } from '../../../../../models/protocols/component-can-deactivate';
import { ChangePasswordViewModel } from '../../../viewModels/change-password-view-model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseModal } from '../../../../../models/base/base-modal';
import { ReactiveFormGroupComponent } from '@mobilefirstdev/reactive-form';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: false
})
export class ChangePasswordComponent extends BaseModal implements ComponentCanDeactivate {
  @ViewChild(ReactiveFormGroupComponent) passwordForm: ReactiveFormGroupComponent;

  constructor(
    public viewModel: ChangePasswordViewModel,
    protected activeModal: NgbActiveModal
  ) {
    super(activeModal);
  }

  override setupBindings() {
    const s = this.viewModel.dismissModalSubject.subscribe(close => {
      if (close) this.cancel();
    });
    this.pushSub(s);
  }

  override cancel() {
    super.cancel();
  }

  canDeactivate(): boolean | Promise<any> {
    return !this.viewModel.unsavedChanges;
  }

  override setupViews() {}
}
